const ROOT = 'UNIT_PAYMENT_DETAILS_TABS_CARDS_';

const actions = {
  LOAD_CARDS_REQUEST: `${ROOT}LOAD_CARDS_REQUEST`,
  LOAD_CARDS_SUCCESS: `${ROOT}LOAD_CARDS_SUCCESS`,
  LOAD_CARDS_ERROR: `${ROOT}LOAD_CARDS_ERROR`,
} as const;

export default actions;
